export default __webpack_public_path__ + "static/media/custom-map-marker-selected.60fb2275.svg";